let defaultOptions = {};

function getDefaultOptions() {
  return defaultOptions;
}

export { getDefaultOptions };
